class BlogSegmentFilter extends HTMLElement {
  connectedCallback() {
    this.buttons = this.querySelectorAll('[data-segment-filter]');
    this.list = document.querySelector('[data-segment-list]');
    if (!this.list) return;

    this.items = this.list.querySelectorAll('[data-segment-item]');
    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.filter(button));
    });
  }

  filter(activeButton) {
    const segment = activeButton.dataset.segmentFilter;
    this.buttons.forEach((button) => button.classList.toggle('is-active', button === activeButton));
    this.items.forEach((item) => {
      const matches = segment === 'all' || item.dataset.segment === segment;
      item.hidden = !matches;
    });
  }
}

if (!customElements.get('blog-segment-filter')) {
  customElements.define('blog-segment-filter', BlogSegmentFilter);
}
